import React, { useState, useEffect } from "react"
import { Container, Grid, useMediaQuery } from "@material-ui/core"
import "./questionnaires-administration-edit-questionnaire.view.css"
import LabelPure from "../../pures/label/label.pure"
import { ArrowBtnHLPure, ButtonAddHLPure, ButtonHLPure, DialogSystemGLPure, DialogTemplatePure, DropDownBtnHLPure, InputHLPure, SimpleLoading, TextAreaHLPure, DialogFormHLPure } from "../../pures"
import { NIL as NIL_UUID } from 'uuid'
import { QuestionnaireService, ContractService } from "../../../services"
import { useTranslation } from "react-i18next"
import StandardTemplatesView from "./standard-templates.view"
import { RadioButton } from "@progress/kendo-react-inputs"

const QuestionnairesAdministrationEditDetailView = ({
    selectedQuestionnaire,
    companySelected,
    user,
    token,
    hideShowDetails,
    showDetailComponent,
    toggleCompleteRequest,
    toggleShowDetailComponent,
    showCompletedRequest,
    setShowComponentDetail,
    setStateNameComponentUser,
    setHeaderTitleinDetail,
    setNameComponentUser,
    setShowDetails,
    setTemplateSelected,
    toggleErrorRequesting,
    toggleLoadingRequesting,
    toggleCompletedRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    showLoadingRequesting,
    templates,
    setTemplates,
    nameComponentUser,
    setIdTemplateDuplicate,
    icons

}) => {

    const { t } = useTranslation();

    const isMobile = useMediaQuery("(max-width:560px)")

    const questionnaireName = selectedQuestionnaire && selectedQuestionnaire.name && selectedQuestionnaire.name !== '' && selectedQuestionnaire.name !== null && selectedQuestionnaire.name !== undefined
        ? selectedQuestionnaire.name : ''
    const descriptionValue = selectedQuestionnaire && selectedQuestionnaire.description && selectedQuestionnaire.description !== '' && selectedQuestionnaire.description !== null && selectedQuestionnaire.description !== undefined
        ? selectedQuestionnaire.description : ''

    const [name, setName] = useState(questionnaireName)
    const [description, setDescription] = useState(descriptionValue)
    const [idTemplate, setidTemplate] = useState('Sin template');
    const [showGettingData, setShowGettingData] = useState(false);
    const [nameVoidWarning, setNameVoidWarning] = useState(false);
    const [showLoadingRequest, setShowLoadingRequest] = useState(false);
    const [nameCompany, setNameCompany] = useState(t("questionnairesAssignCategories.no.assign"));
    const [error, setError] = useState(false);
    const [showWarningRequesting, setShowWarningRequesting] = useState(false);
    const [showModal, setShowModal] = useState(false)
    const [copyComplteTemplates, setCopyCompleteTemplates] = useState([])
    const [templatesToShow, setTemplatesToShow] = useState([])
    const [messageError, setMessageError] = useState('')
    const [showStandardTemplates, setShowStandardTemplates] = useState(false)
    const [imageTitle, setImagetitle] = useState(null);
    const [showDialogIcon, setShowDialogIcon] = useState(false)

    let templatesToDrop = [{
        active: true,
        clientId: 0,
        companyId: NIL_UUID,
        createdDate: "",
        deactivationReason: null,
        description: "",
        documentLoaded: null,
        documentPath: null,
        id: NIL_UUID,
        name: "Sin template",
        templateVariable: [],
        updatedDate: "",
        variableCount: null
    }]

    const modifiedByEmail = selectedQuestionnaire && selectedQuestionnaire.updatedByUser !== null ? selectedQuestionnaire.updatedByUser : ''
    const dateModified = selectedQuestionnaire ? selectedQuestionnaire.updatedDate : ''

    useEffect(() => {
        if (nameComponentUser === t("questionnairesAdministrationEditDetailView.btn.add.questionnaire")) {
            return
        }
        let allData = []
        let copyTemplates = [...templates]
        if (selectedQuestionnaire.id !== NIL_UUID) {
            let addTemplate = copyTemplates.filter((template) => {
                return (
                    template.id === selectedQuestionnaire.template.id
                );
            });
            let newTemplate = copyTemplates.filter((template) => template.id !== selectedQuestionnaire.template.id)
            if (addTemplate && addTemplate.length > 0) {
                newTemplate.unshift(addTemplate[0])
                setidTemplate(addTemplate[0].id)
                newTemplate.push(templatesToDrop[0])
            } else {
                newTemplate.push(templatesToDrop[0])
            }
            for (let i = 0; i < newTemplate.length; i++) {
                if (newTemplate[i].name !== '' && newTemplate[i].id !== '') {
                    allData.push(newTemplate[i])
                }
                // allData.name = newTemplate[i].name
                // allData.push(allData.name)
            }
            // let dataConvert = Object.values(allData);
            setCopyCompleteTemplates(newTemplate)
        } else {
            copyTemplates.push(templatesToDrop[0])
            for (let i = 0; i < copyTemplates.length; i++) {
                allData.name = copyTemplates[i].name
                allData.push(allData.name)
            }
            setCopyCompleteTemplates(copyTemplates)
        }

        allData = allData.filter(template => template.clientId !== null && template.companyId !== null)

        setTemplatesToShow([{
            id: "0",
            name: t("digitalContractHomeView.questionnaires.assignTemplate")
        }, ...allData])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [templates])



    const handleNameQuestionnaire = (e) => {
        setName(e.target.value)
    }

    const handleDescription = (e) => {
        setDescription(e.target.value)
    }

    const handleChangeDropTemplate = (e) => {
        setidTemplate(e.target.value)
        setIdTemplateDuplicate(e.target.value)
    }

    useEffect(() => {
        if (companySelected.length > 0) {
            if (companySelected[0].id !== NIL_UUID) {
                setNameCompany(companySelected[0].companyName)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    useEffect(() => {
        if (companySelected.length > 0) {
            if (companySelected[0].id !== NIL_UUID) {
                setNameCompany(companySelected[0].companyName)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const saveQuestionnaire = async () => {
        let userId = user.userMetaData.userA3Cloud.clientId;
        const logo = imageTitle && imageTitle !== "" && imageTitle !== undefined && imageTitle !== null ? imageTitle : ''
        const id = selectedQuestionnaire.id
        // let templateIdSelect= NIL_UUID
        // if(idTemplate !== 'Sin template'){
        //    let selectIdTemplate = copyComplteTemplates.filter((template) => template.id === idTemplate)
        //     templateIdSelect = selectIdTemplate[0].id
        // }
        const templateId = idTemplate
        let questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);
        let contractService = new ContractService(process.env.REACT_APP_MIFIRMA_API);
        let questionnaireCreated = await questionnaireService.updateQuestionnaireById(id, name, description, templateId, logo, token)
        if (questionnaireCreated && Number(questionnaireCreated.statusCode) === 200) {
            let questionnaires = await contractService.getQuestionnairesByUserId(token, userId)
            await toggleLoadingRequesting(false)
            await toggleCompletedRequesting(true, '', questionnaires.data.data)
            setTimeout(() => {
                hideShowDetails()
            }, 4000)
        } else {
            await toggleLoadingRequesting(false)
            await toggleErrorRequesting(true)
            setTimeout(() => {
                toggleErrorRequesting(false)
            }, 2000);
        }
    }

    const saveQuestionnaireModifiedTemplate = async () => {
        await toggleLoadingRequesting(true)
        setShowModal(false)
        const questionnaireId = selectedQuestionnaire.id
        let questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);
        //mandar a llamar a la funcion para eliminar las preguntas del cuestionario 
        try {
            let questionsDeleted = await questionnaireService.deleteQuestionsforQuestionnaireByQuestionaireId(questionnaireId, token)
            if (questionsDeleted && Number(questionsDeleted.statusCode) !== 200) {
                await toggleLoadingRequesting(false)
                toggleErrorRequesting(true)
                setTimeout(() => {
                    toggleErrorRequesting(false)
                }, 2000);
            }
            saveQuestionnaire()

        } catch (error) {
            await toggleLoadingRequesting(false)
            await toggleErrorRequesting(true)
            setTimeout(() => {
                toggleErrorRequesting(false)
            }, 2000);
        }
    }


    const handlesaveQuestionnaire = async () => {
        if (name === '' || idTemplate == "0" || idTemplate == t("questionnairesAssignCategories.no.assign")) {
            setNameVoidWarning(true)
            setMessageError(name == '' ? t("questionnairesAdministrationNewQuestionnaireView.input.name.warning.label") : t("questionnairesAdministrationNewQuestionnaireView.input.template.warning.label"))
            setTimeout(() => {
                setNameVoidWarning(false)
            }, 2000);
        } else {
            let template = copyComplteTemplates.filter((template) => template.id === idTemplate)

            if (selectedQuestionnaire.template.id === template[0].id) {
                await toggleLoadingRequesting(true)
                // update a questionnaire
                saveQuestionnaire()
            } else {
                await toggleLoadingRequesting(false)
                setShowModal(true)
            }

        }
    }

    const toggleWarningRequesting = () => {
        setShowWarningRequesting(false)
    }

    const closeModal = () => {
        setShowModal(false)
    }

    //set template related to duplicate questionnaire
    useEffect(() => {
        if (nameComponentUser === t("questionnairesAdministrationEditDetailView.btn.add.questionnaire")) {
            return
        }
        if (selectedQuestionnaire && selectedQuestionnaire.template.id !== NIL_UUID) {
            setIdTemplateDuplicate(selectedQuestionnaire.template)
        } else {
            setIdTemplateDuplicate(templatesToDrop)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedQuestionnaire])

    const selectedTemplate = copyComplteTemplates.find(template => template.id == idTemplate)

    const toggleDialogIcon = () => {
        setShowDialogIcon(!showDialogIcon);
    };


    const onCancelIcon = () => {
        toggleDialogIcon();
        setImagetitle(null);
    };

    //save icon
    const onSaveImg = (e) => {
        e.preventDefault();
        toggleDialogIcon();
    };

    return showGettingData ? (
        <div className="questionnairesAdministrationNewQuestionnaireView-loader">
            <SimpleLoading />
        </div>
    ) : (
        <>
            <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="questionnairesAdministrationEditDetailView-wrapper"
            >
                {showLoadingRequesting ? <DialogSystemGLPure toggleLoadingRequesting={toggleLoadingRequesting} showLoadingRequesting={showLoadingRequesting} /> : null}
                {showCompletedRequesting ? (<DialogSystemGLPure showCompletedRequesting={showCompletedRequesting} toggleCompletedRequesting={toggleCompletedRequesting} />) : null}
                {nameVoidWarning ? <DialogSystemGLPure toggleWarningRequesting={toggleWarningRequesting} showWarningRequesting={nameVoidWarning} message={messageError} /> : null}
                {showErrorRequesting ? <DialogSystemGLPure toggleErrorRequesting={toggleErrorRequesting} showErrorRequesting={showErrorRequesting} /> : null}

                {
                    showStandardTemplates
                        ? <StandardTemplatesView
                            toggleErrorRequesting={toggleErrorRequesting}
                            onBack={() => setShowStandardTemplates(false)}
                            onSelect={(template) => {
                                setidTemplate(template.id)
                                setIdTemplateDuplicate(template.id)
                            }}
                        />
                        : <Container disableGutters maxWidth={"lg"}>
                            <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="QuestionnairesAdministrationEditDetailView-subtitle"
                            >
                                {
                                    nameCompany !== t("questionnairesAssignCategories.no.assign")
                                        ? <div className="questionnairesAdministrationNewQuestionnaireView-subtitle">
                                            <LabelPure title={`${t("questionnairesAdministrationNewQuestionnaireView.label.name.questionnaire.for.company")} ${nameCompany}`} />
                                        </div>
                                        : <div className="questionnairesAdministrationNewQuestionnaireView-subtitle">
                                            <LabelPure title={`${t("questionnairesAdministrationNewQuestionnaireView.label.name.questionnaire.for.company.sin.asignar")} ${nameCompany}`} />
                                        </div>
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <Grid
                                    container
                                    spacing={4}
                                    wrap
                                    className="questionnairesAdministrationEditDetailView-container"
                                >
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}
                                        className="questionnairesAdministrationEditDetailView-container-left"
                                    >
                                        <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className=""
                                        >

                                            <InputHLPure
                                                labelInput={t("questionnairesAdministrationNewQuestionnaireView.label.name.questionnaire")}
                                                typeInput={"text"}
                                                valueInput={name}
                                                tooltipShow
                                                positionTooltip={isMobile ? "top" : "right"}
                                                titleTooltip={t("questionnairesAdministrationNewQuestionnaireView.input.name.tooltip.title")}
                                                descriptionTooltip={t("questionnairesAdministrationNewQuestionnaireView.input.name.tooltip.description")}
                                                handleChangeInput={(e) => handleNameQuestionnaire(e)}
                                                informationIcon={true}
                                                inputActive={true}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="questionnairesAdministrationEditDetailView-template"
                                        >
                                            <DropDownBtnHLPure
                                                labelDropDown={t("questionnairesAdministrationNewQuestionnaireView.label.title.name.template")}
                                                optionsDropDown={templatesToShow}
                                                valueItem="id"
                                                nameOption="name"
                                                onDropDownChange={(e) => handleChangeDropTemplate(e)}
                                                tooltipShow={true}
                                                positionTooltip={isMobile ? "top" : "right"}
                                                titleTooltip={t("questionnairesAdministrationNewQuestionnaireView.input.name.tooltip.title")}
                                                descriptionTooltip={t("questionnairesAdministrationNewQuestionnaireView.input.name.tooltip.description")}
                                                informationIcon={true}
                                                optionsValue={idTemplate}
                                            />
                                        </Grid>

                                        {
                                            (idTemplate == "0" || idTemplate == 'Sin template' || (selectedTemplate && selectedTemplate.clientId == null && selectedTemplate.companyId == null)) &&
                                            <Grid item xs={12} className="questionnairesAdministrationEditDetailView-template questionnairesAdministrationNewQuestionnaireView-standardTemplate">
                                                <ArrowBtnHLPure
                                                    textArrowBtn={(selectedTemplate && selectedTemplate.companyId == null && selectedTemplate.clientId == null) ? selectedTemplate.name : 'Contratos Estándar'}
                                                    onClickArrowBtn={() => setShowStandardTemplates(true)}
                                                />
                                            </Grid>
                                        }
                                    </Grid>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}
                                        className="questionnairesAdministrationEditDetailView-text-area"
                                    >
                                        <TextAreaHLPure
                                            labelTextArea={t("questionnairesAdministrationNewQuestionnaireView.title.description.texarea")}
                                            valueTextData={description}
                                            positionTooltip={isMobile ? "top" : "right"}
                                            handleChangeTextArea={(e) => handleDescription(e)}
                                        />
                                        <div className="questionnairesAdministrationEditDetailView-icon">
                                            <ButtonAddHLPure
                                                iconAdd={true}
                                                nameBtn={t("digitalContractDashboard.questionnaires.iconTitle")}
                                                onClickBtn={() => toggleDialogIcon()}
                                            />
                                        </div>

                                        <div className="questionnairesAdministrationEditDetailView-modified-text-area">
                                            <LabelPure title={`${t("questionnairesAdministrationEditDetailView.label.modified.by")} ${modifiedByEmail} el ${dateModified}`} />
                                        </div>

                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className="questionnairesAdministrationEditDetailViewa-container-btn"
                            >
                                <ButtonHLPure
                                    nameBtn={t("button.cancel")}
                                    onClickBtn={showDetailComponent ? toggleShowDetailComponent : hideShowDetails}
                                />

                                <ArrowBtnHLPure
                                    textArrowBtn={t("questionnairesAdministrationEditDetailView.btn.duplicate.questionnaire")}
                                    onClickArrowBtn={() => {
                                        let template = templates.filter((template) => template.id === idTemplate)
                                        setTemplateSelected(template)
                                        setNameComponentUser(t("questionnairesAdministrationEditDetailView.btn.duplicate.questionnaire"));
                                        setShowDetails(true);
                                    }}
                                    primary={false}
                                />

                                <ArrowBtnHLPure
                                    textArrowBtn={t("questionnairesAdministrationView.grid.assign.categories")}
                                    onClickArrowBtn={() => {
                                        setNameComponentUser(t("questionnairesAdministrationView.grid.assign.categories"));
                                        setShowDetails(true);
                                    }}
                                    primary={false}
                                />

                                <ArrowBtnHLPure
                                    textArrowBtn={t("questionnairesAdministrationEditDetailView.btn.manage.questions")}
                                    onClickArrowBtn={() => {
                                        setNameComponentUser(t("questionnairesAdministrationView.btn.adm.questions.grid"));
                                        setShowDetails(true);
                                    }}
                                    primary={false}
                                />

                                <ButtonHLPure
                                    nameBtn={t("button.save")}
                                    primary
                                    onClickBtn={handlesaveQuestionnaire}
                                />
                            </Grid>
                        </Container>
                }
            </Grid>


            {showModal && (
                <DialogTemplatePure
                    title={t("questionnairesAdministrationEditDetailView.modal.title")}
                    description={t("questionnairesAdministrationEditDetailView.modal.description")}
                    saveBtn={t("button.save")}
                    canelBtn={t("button.cancel")}
                    cancel={closeModal}
                    handleSubmitProfile={saveQuestionnaireModifiedTemplate}
                >
                    <h1>{t("questionnairesAdministrationEditDetailView.modal.question")}</h1>
                </DialogTemplatePure>
            )}
            {showDialogIcon && (
                <DialogFormHLPure
                    cancel={onCancelIcon}
                    titleDialog={t(
                        "dialogSignRequestPure.titleDialogSignRequest"
                    )}
                    descriptionActive={true}
                    descriptionDialog={t(
                        "questionnairesAdministrationView.dialog.choose.icon.description"
                    )}
                    textBtnCancel={t("button.cancel")}
                    saveBtn={t("button.save")}
                    handleSubmit={(event) => onSaveImg(event)}
                // loadingComponent={isLoading}
                >
                    <div
                        className="signatureProfilesDetailsView-container-gallery"
                        sm={12}
                        xs={12}
                        lg={12}
                        md={12}
                    >
                        {icons.map((item, index) => (
                            <div className="signatureProfilesDetailsView-container-icons">
                                <RadioButton
                                    className="signatureProfilesDetailsView-radioBtn-img"
                                    name="icon"
                                    value={item.path}
                                    checked={imageTitle === item.path}
                                    onChange={({ value }) => setImagetitle(value)}
                                />
                                <img
                                    src={item.path}
                                    {...item}
                                    className="icon-style"
                                    key={index}
                                />
                            </div>
                        ))}
                    </div>
                </DialogFormHLPure>
            )}
        </>
    );
}
export default QuestionnairesAdministrationEditDetailView;